const colorLevelTresholds = [0, 10, 20, 30, 40] as const;

export type ColorLevelTreshold = (typeof colorLevelTresholds)[number];

export const LEVEL_GRADIENTS: Record<ColorLevelTreshold, [string, string]> = {
  0: ['var(--c-white)', '#A3A3A3'],
  10: ['#FFA800', '#9A4D06'],
  20: ['#FF4E22', '#701600'],
  30: ['#09F', '#025186'],
  40: ['#2E0079', '#0E003C'],
};

export const getLevelTreshold = (level: number): ColorLevelTreshold => {
  return Number(
    colorLevelTresholds.filter(lvl => level >= +lvl).pop() ||
      colorLevelTresholds[0]
  ) as ColorLevelTreshold;
};
